// extracted by mini-css-extract-plugin
export default {"qrCode":"xThtqArz1OVkTG7DaKnT"};